// Retention Engine (P2) worklist. List comes from GET /v1/bo/retention/batch
// (custom endpoint, sorted MERAH-first/closest-expiry-first — see
// backoffice.routes.js -> models.retentionEngine.getBatchList); updates go through
// the generic CRUD engine (PUT /crud/churn_retention_log/:id) so the "Status"
// dropdown can reuse the same inline-edit mechanism as other modules.
//
// No WhatsApp Business API / Mailchimp integration exists — nothing here is sent
// automatically. "Kirim" work happens outside this system (WhatsApp/Mailchimp
// directly); switch Status to "sent" here afterwards so the frequency cap in
// libs/retentionEngine.js knows this member was just contacted.
const STATUSES = [
  "draft_ready",
  "pending_mentor_review",
  "approved",
  "sent",
  "skipped",
  "failed",
];

let churnRetentionLogSection = {
  name: "Retention Worklist",
  slug: "churnRetentionLog",
  visible: true,
  singularName: "churnRetentionLog",
  crud: true,
  endpoint: "/v1/bo/retention/batch",
  updateEndpoint: "/crud/churn_retention_log",
  updateLabel: "churnRetentionLog",
  filters: [],
  meta: {
    delete_flag: false,
  },
  access: ["superadmin"],
  delete: false,
  add: false,
  update: true,
  edit: false,
  exportToCsv: true,
  fields: [
    {
      label: "Nama",
      name: "name",
      type: "text",
      input: false,
      resource_label: (row) => (row && row.name ? row.name : "-"),
    },
    {
      label: "Kontak",
      name: "txt",
      type: "text",
      input: false,
      resource_label: (row) =>
        row && row.channel === "whatsapp" ? row.phone || "-" : (row && row.email) || "-",
    },
    {
      label: "Klasifikasi",
      name: "txt",
      type: "text",
      input: false,
      resource_label: (row) => {
        const icon = { HIJAU: "🟢", KUNING: "🟡", MERAH: "🔴" }[row.classification] || "";
        return `${icon} ${row.classification || "-"}`;
      },
    },
    {
      label: "Days to Expiry",
      name: "txt",
      type: "text",
      input: false,
      resource_label: (row) => (row.days_to_expiry != null ? row.days_to_expiry : "-"),
    },
    {
      label: "Reason",
      name: "txt",
      type: "text",
      input: false,
      resource_label: (row) => (row.reason_code ? row.reason_code : "-"),
    },
    {
      label: "Channel",
      name: "txt",
      type: "text",
      input: false,
      resource_label: (row) => (row.channel ? row.channel : "-"),
    },
    {
      label: "Draft Pesan",
      name: "txt",
      type: "text",
      input: false,
      resource_label: (row) => (row.message_draft ? row.message_draft : "-"),
    },
    {
      label: "Status",
      name: "status",
      type: "lookup",
      editable: true,
      values: STATUSES.map((s) => ({ value: s, text: s })),
      resource_label: (row) => (row && row.status ? row.status : "-"),
      defaultValue: (row) => (row ? row.status : "draft_ready"),
    },
  ],
};

export default [churnRetentionLogSection];
